const AngledLine = require('./shapes/AngledLine.js');
const RandomOutline = require('./shapes/RandomOutline.js');
const RandomRect = require('./shapes/RandomRect.js');

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-random-outline]', function () {
		new RandomOutline(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-random-rect]', function () {
		new RandomRect(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-angled-line]', function () {
		new AngledLine(this);
	});

});
